import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Translate, useTranslate } from 'core/translate';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalFooterMessage,
  ModalFooterButtons,
  ModalFooterCancelButton,
  ModalFooterPrimaryButton
} from '../../common/modal/Modal';

const Warning = ({ packages, onSelect, onClose }) => {
  const translate = useTranslate();
  const packageString = _.flatMap(packages, x => x.options)
    .filter(x => x.selected)
    .map(x => x.description)
    .join(', ');
  const header = translate('configuration.assistant');

  return (
    <Modal isOpen={true} contentLabel={header} onRequestClose={onClose}>
      <ModalHeader icon="bell" text={header} onClose={onClose} />
      <ModalBody>
        <div className="modal-body__content">
          <div>
            <div
              className="modal-body__description-container"
              dangerouslySetInnerHTML={{
                __html: translate(
                  packageString
                    ? 'alert.reset.config'
                    : 'alert.reset.config.default',
                  { packages: packageString }
                )
              }}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalFooterMessage>
          <Translate value="confirm.continue" />
        </ModalFooterMessage>
        <ModalFooterButtons>
          <ModalFooterCancelButton onClick={onClose} data-dtm={header} />
          <ModalFooterPrimaryButton onClick={onSelect} data-dtm={header} />
        </ModalFooterButtons>
      </ModalFooter>
    </Modal>
  );
};

Warning.propTypes = {
  packages: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default Warning;
